import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BRAND_IMAGE =
  "https://customer-assets-0z36b82j.emergentagent.net/job_poppins-apply/artifacts/u9c75rd5_AXB5w.jpg";
